import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '@environments/environment';
import { LogService } from '@services/log.service';

@Component({
  selector: 'app-landing',
  imports: [MatButtonModule, RouterModule],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss'
})
export class LandingComponent {

  header = environment.header;
  highlightHeader = environment.highlightHeader;
  primaryHeader = environment.primaryHeader;
  description = environment.description.split(',');

  constructor(private logService: LogService) {
    console.log('LandingComponent initialized', this.description);
    
    // Log page view - no metadata needed for landing
    this.logService.logPageView('landing', {});
    
    // You can add any additional initialization logic here if needed
  }
}
